import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'domSecurity'
})
export class DomSecurityPipe implements PipeTransform {

  constructor(private domsanitaizer: DomSanitizer) { }

  transform(value: any): any {
    return this.domsanitaizer.bypassSecurityTrustResourceUrl(value);
  }

}
